export default "__VITE_ASSET__DGGdBOb2__"